import React, { Fragment } from "react";
import { Drawer } from "antd";
import "antd/dist/antd.css";

/**
 * @author
 * @function CustomDrawer
 **/

const CustomDrawer = ({ open, onClose, title,children }) => {
  // const

  return (
    <Fragment>
      <Drawer
        title={title}
        placement={"bottom"}
        closable={true}
        onClose={onClose}
        visible={open}
        key={"bottom"}
        height={400}
      >
        {children}
      </Drawer>
    </Fragment>
  );
};

export default CustomDrawer;
